module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row m-b-15"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.name),
      expression: "activity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.title),
      expression: "activity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.sort),
      expression: "activity.sort"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.activity.sort)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動說明(後台)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.description),
      expression: "activity.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "活動說明",
      "maxlength": "256"
    },
    domProps: {
      "value": (_vm.activity.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.content),
      expression: "activity.content"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "活動說明",
      "maxlength": "256"
    },
    domProps: {
      "value": (_vm.activity.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "content", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_vm._m(4), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.activity.aTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule"
  }, [_vm._m(5), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.activity.aTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("活動備註")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.remark),
      expression: "activity.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "活動說明"
    },
    domProps: {
      "value": (_vm.activity.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('h5', [_vm._v("參與店家")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "box-body col-xs-12"
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單類型\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "訂單類型",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data[0].limit.order_type),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data[0].limit, "order_type", $$v)
      },
      expression: "activity.strategy_data[0].limit.order_type"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  訂單方案\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderMethod,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "訂單方案",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data[0].limit.order_method),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data[0].limit, "order_method", $$v)
      },
      expression: "activity.strategy_data[0].limit.order_method"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  取貨方式\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.deliveryType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "取貨方式",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data[0].limit.delivery_type),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data[0].limit, "delivery_type", $$v)
      },
      expression: "activity.strategy_data[0].limit.delivery_type"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                  付款地點\n                ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.payPlaceType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "付款地點",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.activity.strategy_data[0].limit.pay_place_type),
      callback: function($$v) {
        _vm.$set(_vm.activity.strategy_data[0].limit, "pay_place_type", $$v)
      },
      expression: "activity.strategy_data[0].limit.pay_place_type"
    }
  })], 1)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低應付金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data[0].limit.min_total_paid_money),
      expression: "activity.strategy_data[0].limit.min_total_paid_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "包含扣除折價",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data[0].limit.min_total_paid_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data[0].limit, "min_total_paid_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低總金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data[0].limit.min_total_money),
      expression: "activity.strategy_data[0].limit.min_total_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data[0].limit.min_total_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data[0].limit, "min_total_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("訂單最低購買數(單位：個)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data[0].limit.min_total_amount),
      expression: "activity.strategy_data[0].limit.min_total_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data[0].limit.min_total_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data[0].limit, "min_total_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低應付金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data[0].limit.min_paid_money),
      expression: "activity.strategy_data[0].limit.min_paid_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "包含扣除折價",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data[0].limit.min_paid_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data[0].limit, "min_paid_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低總金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data[0].limit.min_money),
      expression: "activity.strategy_data[0].limit.min_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data[0].limit.min_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data[0].limit, "min_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低購買數(單位：個)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data[0].limit.min_amount),
      expression: "activity.strategy_data[0].limit.min_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data[0].limit.min_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data[0].limit, "min_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制子單(跟團單)最低訂單數(單位：筆)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.strategy_data[0].limit.min_sub_order_amount),
      expression: "activity.strategy_data[0].limit.min_sub_order_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.activity.strategy_data[0].limit.min_sub_order_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.strategy_data[0].limit, "min_sub_order_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkActivity
    }
  }, [_vm._v("\n      新增\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")])]), _vm._v(" "), _vm._l((_vm.couponList), function(cInfo, index) {
    return _c('div', [_c('div', {
      staticClass: "modal fade",
      attrs: {
        "id": 'couponRegisterModal' + index,
        "role": "dialog"
      }
    }, [_c('div', {
      staticClass: "modal-dialog choose-modal"
    }, [_c('div', {
      staticClass: "modal-content pull-left"
    }, [_vm._m(7, true), _vm._v(" "), (_vm.coupon.coupon_info) ? _c('div', {
      staticClass: "card m-y-1 pull-left m-y-10 c-pointer",
      staticStyle: {
        "width": "calc(100% - 80px)"
      },
      attrs: {
        "data-target": '#couponRegisterModal' + index,
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.clickCoupon()
        }
      }
    }, [_c('div', {
      staticClass: "coupon-left p-10"
    }, [_c('h4', [(_vm.coupon.coupon_info.name) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.name))]) : _c('span', [_vm._v("優惠券名稱")])]), _vm._v(" "), _c('h5', [(_vm.coupon.coupon_info.description) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.description))]) : _c('span', [_vm._v("優惠券描述....")])]), _vm._v(" "), _c('h5', [_vm._v("到期："), (_vm.coupon.time_config.start_time.time) ? _c('span', [_vm._v(_vm._s(_vm.coupon.time_config.start_time.time) + " ~ " + _vm._s(_vm.coupon.time_config.end_time.time))]) : _c('span', [_vm._v(_vm._s(_vm.nowTime) + " ~ " + _vm._s(_vm.nowTime))])])]), _vm._v(" "), _c('div', {
      staticClass: "coupon-right p-10"
    }, [_c('div', {
      staticClass: "v-middle"
    }, [_vm._v("\n                $"), (_vm.coupon.coupon_info.discount_value) ? _c('span', [_vm._v(_vm._s(_vm.coupon.coupon_info.discount_value))]) : _c('span', [_vm._v("10")])])])]) : _vm._e()])])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動名稱(後台)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動名稱(前端)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動順序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動說明(前端)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動開始時間\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("活動結束時間\n                      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('div', [_c('h4', [_vm._v("限制規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header pull-left w-100-p"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("優惠券設定")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4881ae54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Marketing/Temp/ActivityBuyForm.vue
// module id = 2405
// module chunks = 1